/**
* @fileoverview This file is generated by the Angular template compiler.
* Do not edit.
* @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
* tslint:disable
*/ 
var styles = [""];
export { styles as styles };



// WEBPACK FOOTER //
// /codebuild/output/src3658806670/src/client/web-client/src/app/app.component.css.shim.ngstyle.js.pre-build-optimizer.js